module.exports = __webpack_public_path__ + "static/img/108004.5e45dc26.png";